// extracted by mini-css-extract-plugin
export var contentBody = "_dk-9";
export var headerImage = "_dk-2";
export var imageButton = "_dk-7";
export var imageButtonIcon = "_dk-8";
export var imageHeader = "_dk-4";
export var imageHeaderText = "_dk-5";
export var imageOverlay = "_dk-3";
export var imageTitle = "_dk-6";
export var imageWrapper = "_dk-1";
export var taskList = "_dk-a";
export var widget = "_dk-0";